module.exports = __webpack_public_path__ + "static/media/perspectico_logo.c647c7e5.avif";